<template>
    <div class="footer">
        <!-- 繁体中文 -->
        <div class="footer-cn">
            <div class="footer-row">
                <p>
                    <img src="@/assets/imgs/logo-cn.png" class="logo" />
                </p>
            </div>
            <div class="footer-row">
                <p>{{ $t("company.text9") }}</p>
            </div>
            <div class="footer-row">
                <p>{{$t("company.text8")}}</p>
            </div>
            <div class="footer-row">
                <p>Copyright &nbsp;&nbsp;&copy;°-{{ new Date().getFullYear() }}&nbsp;&nbsp; 上海亿充美信息技术有限公司版权所有 </p>
            </div>
            <div class="footer-row">
                <div class="contact-links beian">
                    <a
                        class="footer-link"
                        href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33011002014000"
                        target="_blank"
                    >
                        <img
                            style="width:22px;height:22px;"
                            src="	https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
                        />
                    </a>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <a
                        class="footer-link"
                        href="https://www.beian.miit.gov.cn/"
                        target="_blank"
                    >沪ICP备2024067558号-1</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Footer",
    props: {
        isMobile: {
            type: Boolean,
            default: false
        },
        cdnPrefix: {
            type: String,
            default: ""
        }
    },
    data() {
        return {};
    },
    computed: {},
    watch: {},
    mounted() {},
    methods: {}
};
</script>

<style lang="scss">
.footer {
    width: 100%;
    background: #4f251b;
    padding: 20px;
    color: #fff;
    font-size: 16px;
    .footer-row {
        display: flex;
        justify-content: center;
        .contact-links {
            width: 370px;
            margin: 20px auto;
            display: flex;
            justify-content: space-around;
            a {
                color: #fff;
            }
        }
        .contact-links.beian {
            width: auto;
            a {
                color: #a4a4a4;
                &:hover {
                    color: #fff;
                }
            }
        }
        p {
            width: 90%;
            max-width: 810px;
            text-align: center;
            margin: 5px 0;
            color: #a4a4a4;
            .logo,
            .weixin {
                height: 80px;
                margin: 0 20px;
            }
            a {
                margin: 0 3.3%;
                color: #a4a4a4;
                text-decoration: none;
            }
        }
    }
}
@media screen and (max-width: 500px) {
    .footer {
        font-size: 12px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue